import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkTheme = false;

  private darkThemeSubject = new BehaviorSubject<boolean>(localStorage.getItem('darkTheme') === 'true');
  darkTheme$ = this.darkThemeSubject.asObservable();
  
  constructor() {
    // Load the initial theme state from local storage if available
    const savedTheme = localStorage.getItem('darkTheme');
    this.darkTheme = savedTheme === 'true';
    this.applyTheme();
  }

  toggleTheme() {
    const savedTheme = localStorage.getItem('darkTheme');
    this.darkTheme = savedTheme === 'true';
    this.darkTheme = !this.darkTheme;
    localStorage.setItem('darkTheme', this.darkTheme.toString());

    const current = this.darkThemeSubject.value;
    const newTheme = !current;
    this.darkThemeSubject.next(newTheme);

    this.applyTheme();
  }

  isDarkTheme(): boolean {
    return this.darkTheme;
  }

  private applyTheme() {
    if (this.darkTheme) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }

  getCurrentTheme(): boolean {
    return this.darkThemeSubject.value;
  }
}
